module.exports = __webpack_public_path__ + "img/stock0.f26f0c51.png";